const messages = {
  title: "Bonuskertoin",
  bandBonusTitle: "Bonus per rengas kertoimella",
  amountLabel: "Min. renkaiden määrä (*)",
  label: "Bonuskertoin",
  desc: "Bridgestone- ja Firestone-renkaiden määrä. Firestone-renkaista ei makseta euromääräistä bonusta.",
  goals: {
    loyal: "Lojaali",
    bronze: "Pronssi",
    silver: "Hopea",
    gold: "Kulta",
    platinum: "Platina",
  },
  andMore: "ja enemmän",
  chooseTarget: "Valitse",
  selectTarget: "Valitse vuosittainen tavoitteesi {year} täältä:",
  multiplication: "Bonus kerrotaan <b>{factor}</b>:lla",
  minTyres: "<b>Minimi:</b> {tyre} rengasta",
};

export default {
  messages,
};
